// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: `Макет с таким именем уже существует`,
    ACCEPT: `Принять`,
    ACCEPT_ALL: `Принять все`,
    ACCEPT_REJECT_TRANSFER_PENDING: `Ожидание утверждения`,
    ACCEPTED: `Принят`,
    ACCOUNT: `Аккаунт`,
    ACCOUNT_ADDRESS: `Адрес аккаунта`,
    ACCOUNT_COUNTRY: `Страна аккаунта`,
    ACCOUNT_END: `Конец учетной записи`,
    ACCOUNT_NAME: `Имя аккаунта`,
    ACCOUNT_NUMBER: `Номер аккаунта`,
    ACCOUNT_NUMBER_REQUIRED: `Требуется номер аккаунта.`,
    ACCOUNTS: `Аккаунты`,
    ACCUMULATED_DAYS_ON_RENT: `Накопленные дни аренды`,
    ACCUMULATED_DAYS_RENTED: `Суммарное число дней аренды`,
    ACTIONS: `Действия`,
    ACTIVE_WARRANTY: `Активная гарантия`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL: `Активная гарантия (щелкните, чтобы отобразить сведения)`,
    ACTIVE_WARRANTY_Y_N: `Активная гарантия (Y/N)`,
    ACTUAL_AMOUNT_OF_USE: `Фактическое количество использования`,
    ACTUAL_AUDIT: `Фактическая дата аудита`,
    ACTUAL_AUDIT_DATE: `Фактическая дата проведения аудита`,
    ACTUAL_COURIER_NAME: `Имя фактической службы доставки`,
    ACTUAL_H: `Фактическое число часов`,
    ACTUAL_HOURS: `Фактическое число часов`,
    ACTUAL_PC:`Фактические рулоны`,
    ADD_CLAIM: `Добавить рекламацию`,
    ADD_CLAIMS: `Добавить рекламации`,
    ADD_COMPONENT: `Добавить компонент`,
    ADD_OPTION: `Добавить Опция`,
    ADD_REP: `Дополнительный ремонт`,
    ADD_TO_AUDIT: `Добавить в аудит`,
    ADDITIONAL: `Дополнительно`,
    ADDITIONAL_COMMENTS: `Дополнительные комментарии`,
    ADDITIONAL_REPAIR: `Дополнительный ремонт`,
    ADDITIVE: `Дополнение`,
    ADDRESS: `Адрес`,
    ADDRESS_LINE1: `Адрес, строка 1`,
    ADDRESS_LINE1_REQUIRED: `Требуемая строка адреса 1`,
    ADDRESS_LINE2: `Адрес, строка 2`,
    ADJ_CLM: `Корректировать рекламацию`,
    ADJUST_CLAIM: `Корректировать рекламацию`,
    ADJUSTED_HOURS: `Отрегулированные часы`,
    ADJUSTED_QUANTITY: `Регулируемое количество`,
    ADJUSTMENT_TYPE: `Тип корректировки`,
    ADVANCED_CLAIM_SUMMARY: `Продвинутый уровень Сводка по рекламации`,
    AFTER_DELIVERY_INSPECTION: `ПРОВЕРКА ПОСЛЕ ДОСТАВКИ`,
    AGENCY_NAME: `Название агентства`,
    ALL: `Все`,
    ALL_ACCOUNTS: `Все аккаунты`,
    ALL_CLAIMS: `Все рекламации`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: `Все рекламации подлежат рассмотрению (для получения дополнительной информации см. JD WAM 110.08)`,
    ALL_CLAIMS_TAB: `Все рекламации ({count, number})`,
    ALL_PART_REQUESTS: `Все запросы на запчасти`,
    ALL_PART_REQUESTS_WITH_COUNT: `Все запросы на запчасти ({count})`,
    ALL_PARTS_RETURNED: `Возвращены все запчасти`,
    AMOUNT: `Сумма`,
    AMOUNT_1: `Сумма 1`,
    AMOUNT_2: `Сумма 2`,
    AMOUNT_3: `Сумма 3`,
    AMOUNT_OF_USE: `Показатели Использования`,
    AMOUNT_OF_USE_ACCEPETD: `Объем использования, принятый`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `Объем использования успешно создан`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT: `Журнал показателей использования ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED: `Требуется указать показатели использования.`,
    AMOUNT_OF_USE_REJECTED: `Объем использования отклонен`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `Состояние запросов на количество использования`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `Количество запросов на использование ({count})`,
    AMOUNT_OF_USE_REQUIRED: `Требуется указать показатели использования.`,
    AMOUNT_OF_USE_UNITS_REQUIRED: `Требуется указать единицы показателей использования.`,
    AMOUNT_RECORDED: `Записанное количество`,
    AMOUNT_TO_BE_DEBITED: `Сумма для дебетования`,
    APLYPIP: `Применить PIP`,
    APPLICATION: `Применение`,
    APPLICATION_IS_REQUIRED: `Требуется указать способ применения.`,
    APPLY: `Применить`,
    APPLY_TRAVEL: `Разрешить транспортные расходы`,
    APPROVAL_DEALER_COMMENTS: `Комментарии к утверждению дилера`,
    APPROVAL_DETAILS: `Сведения об утверждении`,
    APPROVAL_LEVELS: `Уровень утверждения`,
    APPROVAL_REMARKS: `Примечания к утверждению`,
    APPROVAL_STATUS: `Состояние утверждения`,
    APPROVE: `Утвердить`,
    APPROVE_AMOUNT_OF_USE: `Утвердить объем использования`,
    APPROVE_LABOR_RATE: `Одобрить тариф на оплату труда`,
    APPROVE_MACHINE_STATUS_UPDATE: `Утверждение обновления состояния машины`,
    APPROVE_PIP_CODE_REQUEST: `Одобрить запрос кода программы PIP`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM: `Одобрить рекламацию по специальному решению`,
    APPROVED: `ОДОБРЕНО`,
    APPROVED_CORE_VALUE: `Утвержденная стоимость основного компонента`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: `Дата утверждения не может предшествовать дате настройки.`,
    APPROVED_DIAGNOSTIC_AMOUNT: `Утвержденная Сумма диагностическая`,
    APPROVED_DIAGNOSTIC_HOURS: `Утвержденные Часов диагностические`,
    APPROVED_IS_REQUIRED: `Требуется статус «Утверждено».`,
    APPROVED_LABOR_ADDITIVE: `Утвержденные дополнительные работы`,
    APPROVED_LABOR_AMOUNT: `Утвержденная сумма за работу`,
    APPROVED_LABOR_HOURS: `Утвержденные рабочие часы`,
    APPROVED_LABOR_TOTAL: `Всего утверждено по работе`,
    APPROVED_ON_SHELF_COST: `Утвержденные затраты на хранение`,
    APPROVED_OTHER_CREDITS: `Утвержденные другие выплаты`,
    APPROVED_PARTS: `Утвержденные запчасти`,
    APPROVED_PARTS_ADDITIVE: `Утвержденные дополнительные запчасти`,
    APPROVED_PARTS_TOTAL: `Всего утверждено по запчастям`,
    APPROVED_REJECTED: `Утверждено/отклонено`,
    APPROVED_REPAIR_AMOUNT: `Утвержденная Сумма ремонта`,
    APPROVED_REPAIR_HOURS: `Утвержденные Часов ремонта`,
    APPROVED_TAXES_TOTAL: `Всего утверждено по налогам`,
    APPROVED_TRAVEL_TOTAL: `Утвержденное общее количество поездок`,
    APPROVER: `Подборщик`,
    ASCENDING: `возрастающий`,
    ATTACHMENTS: `Вложения`,
    AUDIT_NUMBER: `Номер аудита`,
    AUDIT_PLANNED: `Запланированная дата аудита`,
    AUDIT_REQUIREMENT: `Требования к аудиту`,
    AUDIT_RESULTS: `Результаты аудита`,
    AUDIT_STATUS: `Состояние аудита`,
    AUDIT_SUBMITTED_SUCCESSFULLY: `Успешная отправка результатов аудита`,
    AUDIT_SUMMARY: `Сводка по аудиту`,
    AUDIT_TYPE: `Тип аудита`,
    AUDITS: `Аудиты`,
    AUDITS_DUE_WITH_COUNT: `{countToDisplay} аудитов необходимо провести.`,
    AUDITS_DUE_WITHIN_30_DAYS: `{countToDisplay} {count, plural, one {audit} other {audits}} необходимо провести в ближайшие 30дней.`,
    AUDITS_PAST_DUE_WITH_COUNT: `{countToDisplay} {count, plural, one {audit} other {audits}} просрочено.`,
    AUTHORIZATION_NUMBER: `Номер авторизации`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: `Автоотправка из бизнес-системы дилера`,
    AVAILABLE: `ДОСТУПНО`,
    AVAILABLE_COLUMNS: `Доступные столбцы`,
    AVERAGE_DIAGNOSTICS_HOURS: `Среднее число часов диагностики`,
    AVERAGE_LUG_HEIGHT: `Средняя толщина полотна`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED: `Требуется указать среднюю толщину полотна.`,
    AVERAGE_REPAIR_HOURS: `Среднее число часов ремонта`,
    AVERAGE_REPLACEMENT_HOURS: `Среднее число часов замены`,
    AVERAGE_TECH_PAY_RATE: `Средний тариф на оплату техн. труда`,
    BACK: `Назад`,
    BACK_TO_AUDIT: `Назад к аудиту`,
    BASE_MACHINE: `Базовая машина`,
    BASE_MACHINE_IMPLEMENTS: `Рабочее оборудование базовой машины`,
    BASE_MACHINE_PIN: `Номер PIN базовой машины`,
    BASIC_WARRANTY_ENDS: `Базовая гарантия заканчивается`,
    BASIC_WARRANTY_ESTIMATOR: `Оценщик базовой гарантии`,
    BASIC_WARRANTY_STARTS: `Базовая гарантия начинается`,
    BASIS_FOR_SETTLEMENT: `Основание для расчета`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `Основание для расчетов / замечаний по аудиту`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED: `Требуется указать основание для расчета.`,
    BATTERY: `АККУМУЛЯТОР`,
    BEGIN_DATE: `Дата начала`,
    BRANCH: `Филиал`,
    BUILT: `Собрано`,
    BUSINESS_END: `Бизнес-конец`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: `Возможен ли повторный ввод машины в эксплуатацию?`,
    CANCEL: `Отмена`,
    CERTIFIED_LETTER_SENT: `Заказное письмо отправлено`,
    CGST: `CGST`,
    CHANGE_RESPONSIBLE_DEALER: `Смена ответственного дилера`,
    CHANGE_STATUS: `Изменение статуса`,
    CHANGE_STATUS_FOR: `Изменить статус для {pin}`,
    CHANGED: `Изменено`,
    CHANGED_BY: `Кем изменено`,
    CHANGED_ON: `Дата изменения`,
    CHINESE: `китайский`,
    CITY: `Город`,
    CITY_REQUIRED: `Требуемый город`,
    CLAIM: `Рекламация`,
    CLAIM_COUNT_WITH_PARENTHESIS: `({countToDisplay} {count, plural, one {Claim} other {Claims}})`,
    CLAIM_DEBIT: `Дебет по рекламации`,
    CLAIM_DETAILS: `Сведения о рекламации`,
    CLAIM_DRAFT: `ЧЕРНОВИК`,
    CLAIM_HISTORY: `24 месячная история иска`,
    CLAIM_HISTORY_WITH_COUNT: `24 месячная история иска ({count})`,
    CLAIM_NUMBER: `Номеру рекламации`,
    CLAIM_RECOVER_PERCENTAGE: `({percentage}%)`,
    CLAIM_SEARCH: `Поиск рекламации`,
    CLAIM_STATUS: `Статус рекламации`,
    CLAIM_TYPE: `Типу рекламации`,
    CLAIM_TYPES: `Типы рекламаций`,
    CLAIM_UPDATED_SUCCESSFULLY: `Успешное обновление рекламации`,
    CLAIM_VALUE: `Сумма рекламаций`,
    CLAIM_VALUE_DETAILS: `Сведения о сумме рекламации`,
    CLAIM_WITH_NUMBER: `Рекламация {claimNumber}`,
    CLAIMS: `Рекламации`,
    CLAIMS_IN_PROGRESS: `Рекламации в работе`,
    CLAIMS_IN_PROGRESS_WITH_COUNT: `Рекламации в работе ({count})`,
    CLAIMS_OVERVIEW: `Обзор по рекламациям`,
    CLAIMS_OVERVIEW_TAB: `Обзор по рекламациям ({count})`,
    CLAIMS_WITH_COUNT: `{count} рекламаций`,
    CLICK_FOR_DETAILS: `(Щелкните, чтобы узнать подробнее)`,
    CLICK_TO_VIEW_ALL: `Щелкните для просмотра всех`,
    CLOSE: `Закрыть`,
    CLOSED_PART_REQUESTS: `Запросы закрытых частей`,
    CLOSING: `Закрытие`,
    CLOSING_ACCOUNT: `Закрытие учетной записи`,
    CLOSING_ACCOUNT_WITH_COUNT: `Закрытие учетной записи ({count})`,
    CODE: `Код`,
    COLLAPSE_ALL: `Свернуть все`,
    COMMENT: `Комментарий`,
    COMMENTS: `Комментарии`,
    COMMENTS_IS_REQUIRED: `Требуется ввести комментарии.`,
    COMMENTS_TO_DEALER: `Примечания для дилера`,
    COMMON_LABOR_TYPES_WARNING: `Не все типы работ, доступные для выбранных учетных записей`,
    COMPANY: `Компания`,
    COMPANY_CONTRIBUTION: `Взнос компании`,
    COMPANY_CONTRIBUTION_IS_REQUIRED: `Требуется указать взнос компании.`,
    COMPLAINT_CAUSE: `Какова была диагностика жалобы?`,
    COMPLAINT_CAUSE_IS_REQUIRED: `Требуется диагностика по жалобе.`,
    COMPLAINT_CORRECTION: `Как была устранена жалоба?`,
    COMPLAINT_CORRECTION_IS_REQUIRED: `Требуется ремонт по жалобе.`,
    COMPLETE: `Завершено`,
    COMPLETED: `Выполненные`,
    COMPLETED_BY: `Заполнил`,
    COMPLETED_DATE: `Дата заполнения`,
    COMPLETED_IN_LAST_24_MONTHS: `проведено за последние 24месяца`,
    COMPLETION_STATUS: `Состояние выполнения`,
    COMPONENT: `Компонент`,
    COMPONENT_CODE: `Код компонента`,
    COMPONENT_CREATED_SUCCESSFULLY: `Компонент создан успешно`,
    COMPONENT_DELETED_SUCCESSFULLY: `Компонент удалён успешно`,
    COMPONENT_SERIAL_NUMBER: `Серийный номер компонента`,
    COMPONENT_SUCCESSFULLY_UPDATED: `Компонент успешно обновлен`,
    COMPONENTS: `Компоненты`,
    CONFIRM: `Подтвердить`,
    CONFIRM_ADDITIONAL_REPAIR: `Вы действительно хотите добавить дополнительный ремонт?`,
    CONFIRM_ADJUST_CLAIM: `Вы действительно хотите скорректировать эту рекламацию?`,
    CONFIRM_CLOSING_ACCOUNT: `Действительно принять эту передачу?`,
    CONFIRM_COPY_CLAIM: `Вы уверены, что хотитескопировать эту рекламацию?`,
    CONFIRM_DELETE_ATTACHMENT: `Вы действительно хотите удалить вложение?`,
    CONFIRM_DELETE_CLAIM: `Вы уверены, что хотите удалить эту рекламацию?`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE: `Вы действительно хотите удалить этот запрос состояния машины?`,
    CONFIRM_DELETE_REGISTRATION: `Вы уверены, что хотите удалить эту регистрацию?`,
    CONFIRM_EDIT_CLAIM: `Вы хотите отредактировать это требование?`,
    CONFIRM_RECONCILE_CLAIM: `Вы уверены, что хотите согласовать эту рекламацию?`,
    CONFIRM_RESEND_XML: `Действительно переотправить XML? Подождите 24-48 часов, чтобы она была видна.`,
    CONFIRM_SKIP_AUDIT: `Вы уверены, что хотите пропустить этот аудит?`,
    CONFIRM_UNDO_REGISTRATION: `Действительно отменить эту регистрацию?`,
    CONFIRM_UNRECONCILE_CLAIM: `Вы действительно хотите отменить выверку этой рекламации?`,
    CONNECTED_MACHINE: `Подключенная машина`,
    CONTACTED: `Контакт установлен`,
    CONTAINS: `Содержание`,
    CONTRACT_NUMBER: `Номер контракта`,
    CONTRACT_PURCHASED: `Приобретенный контракт`,
    CONTRACT_TYPE: `Тип контракта`,
    COPY_CLAIM: `Копировать рекламацию`,
    CORE: `Ремфонд`,
    CORE_VALUE: `Стоимость основного компонента`,
    COUNTRY: `Страна`,
    COUNTRY_REQUIRED: `Требуемая страна`,
    COURIER_ACCOUNT_NUMBER: `Номер аккаунта службы доставки`,
    COURIER_NAME: `Имя службы доставки`,
    COVERAGE_DECISION: `Решение о покрытии`,
    COVERAGE_TYPE: `Тип покрытия`,
    CRDMEM: `Гарантийная выплата`,
    CREATE: `Создать`,
    CREATE_CLAIM: `Создать рекламацию`,
    CREATE_LAYOUT: `Создать макет`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT: `Прежде чем зарегистрировать рекламацию по этой продукции, Вам необходимо предоставить нам некоторую важную информацию о ней`,
    CREATE_PIP_CLAIM: `Создание рекламации по программе PIP`,
    CREATE_PIP_CLAIMS: `Создать рекламации по PIP`,
    CREATE_PRODUCT_RECORD: `Создать запись о продукции`,
    CREATE_REQUEST: `Создать запрос`,
    CREATE_TRANSFER_PENDING: `Ожидание передачи`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE: `Невозможно создать услугу трансфера`,
    CREATED: `Дате создания`,
    CREATED_BY: `создателю рекламации`,
    CREATED_DATE: `Дата создания`,
    CREATED_DATE_FROM: `С даты создания`,
    CREATED_DATE_TO: `До даты создания`,
    CREATED_ON: `Дата создания`,
    CREATION_DATE: `Дата создания`,
    CREDIT_MEMO: `Номеру кредитного авизо`,
    CREDIT_MEMO_DATE: `Дата Кредитового Авизо`,
    CREDIT_MEMO_ISSUE_DATE: `Оформлено  кредитное авизо`,
    CREDIT_MEMO_NUMBER: `Номер кредитного авизо`,
    CREDIT_MEMO_PROCESS_DATE: `Обработано кредитное авизо`,
    CREDIT_MEMO_SELECTED: `Выбранное кредитовое авизо`,
    CREDIT_MEMOS: `кредитовое авизо`,
    CRITERIA: `Критерии`,
    CRT: `Создать`,
    CSV_SEPARATOR: `Сепаратор CSV`,
    CURRENCY: `Валюта`,
    CURRENT: `Текущий`,
    CURRENT_ACCOUNT: `Текущий счет`,
    CURRENT_AMOUNT_OF_USE: `Текущие Показатели Использования`,
    CURRENT_CUSTOMER: `Текущий клиент`,
    CURRENT_DEALER: `Текущий дилер`,
    CURRENT_DEALER_DISTANCE: `Текущее расстояние для дилера`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `Текущая дата последнего обслуживания дилера`,
    CURRENT_DEALER_LOCATION: `Текущее местонахождение дилера`,
    CURRENT_HOURS: `Текущие часы`,
    CURRENT_QUANTITY: `Текущее количество`,
    CURRENT_RESPONSIBLE_DEALER: `Текущий ответственный дилер`,
    CURRENT_VALUES: `Текущие значения`,
    CURRENTLY_ON_RENT: `В настоящее время в аренде`,
    CUSTOM_RANGE: `Заданный диапазон`,
    CUSTOM_VALUES: `Специальные значения`,
    CUSTOMER: `Клиент`,
    CUSTOMER_CONTRIBUTION: `Взнос клиента`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED: `Требуется указать взнос клиента.`,
    CUSTOMER_CREATED_SUCCESSFULLY: `Клиент успешно создан.`,
    CUSTOMER_DETAILS: `Сведения о клиенте`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: `Сведения о клиенте успешно обновлены.`,
    CUSTOMER_INFORMATION: `Информация для покупателей`,
    CUSTOMER_INFORMATION_IS_REQUIRED: `Информация о клиенте обязательна.`,
    CUSTOMER_INVALID: `Неверно указан клиент.`,
    CUSTOMER_NAME: `Имя клиента`,
    CUSTOMER_NAME_IS_REQUIRED: `Информация о клиенте обязательна.`,
    CUSTOMER_NOT_FOUND: `Клиент не найден.`,
    CUSTOMER_REQUIRED: `Требуется указать клиента.`,
    CUSTOMER_RESOLUTION: `Решение клиента`,
    CUSTOMER_RESOLUTION_IS_REQUIRED: `Требуется указать решение клиента.`,
    CUSTOMER_SEARCH: `Поиск клиентов`,
    CUSTOMER_UPDATED_SUCCESSFULLY: `Данные о клиенте успешно обновлены.`,
    DAMAGED_MACHINES_HELP_TEXT: `Гарантия на поврежденные машины будет автоматически приостановлена до момента рассмотрения настоящей заявки территориальным менеджером по поддержке клиентов (TCSM) и принятия им решения о восстановлении гарантии. Поврежденные машины могут участвовать только в программах усовершенствования продукции (PIP) категории «Обязательное при сбое» и «Обязательное соблюдение ТБ».`,
    DATE: `Дата`,
    DATE_FORMAT: `Формат даты`,
    DATE_ISSUED: `Дата выпуска`,
    DATE_OF_CERTIFIED_LETTER: `Дата заказного письма`,
    DATE_OF_EVENT_CAUSING_DAMAGE: `Дата события, в результате которого возникло повреждение`,
    DATE_OF_LAST_PERSONAL_CONTACT: `Дата последнего личного контакта`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT: `Дата отгрузки/отправки отозванной запчасти`,
    DATE_REFUSED: `Дата отказа`,
    DATE_SUBMITTED: `Дата отправки`,
    DAYS_FROM_REGISTRATION: `Дни с момента регистрации`,
    DAYS_LEFT: `Осталось дней`,
    DAYS_LEFT_WITH_COUNT: `{daysToDisplay} {days, plural, one {день остался} other {дн. осталось}}`,
    DAYS_ON_RENT: `Арендованные дни`,
    DAYS_REMAINING: `Осталось дней`,
    DAYS_REMAINING_WITH_COUNT: `Осталось: {daysToDisplay} {days, plural, one {Day} other {Days}}`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {день} other {дней}} С момента рекомендации`,
    DAYS_TO_DISPLAY: `Дни для отображения`,
    DBS: `Бизнес-система дилера`,
    DEALER: `Дилер`,
    DEALER_ACCOUNT: `Аккаунт дилера`,
    DEALER_ACCOUNT_IS_REQUIRED: `Требуется указать учетную запись дилера.`,
    DEALER_ACCOUNTS: `Аккаунты дилера`,
    DEALER_CITY: `Город дилера`,
    DEALER_COMMENTS: `Комментарии дилера`,
    DEALER_CONTRIBUTION: `Взнос дилера`,
    DEALER_CONTRIBUTION_IS_REQUIRED: `Требуется указать взнос дилера.`,
    DEALER_HIERARCHY_ACCOUNT: `{account} ({industryIndicator})`,
    DEALER_INVOICE_NUMBER: `Номер счета-фактуры дилера`,
    DEALER_INVOICE_UPDATED: `СЧЕТ-ФАКТУРА ДИЛЕРА ОБНОВЛЕН`,
    DEALER_INVOICE_UPDATES: `Счет-фактура дилера`,
    DEALER_INVOICES: `Счета, выставленные дилером`,
    DEALER_LOCATION: `Местонахождению дилера`,
    DEALER_LOCATION_FILTER: `Местонахождение фильтров`,
    DEALER_LOCATION_IS_REQUIRED: `Требуется указать дилерский центр.`,
    DEALER_LOCATIONS: `Дилерские центры`,
    DEALER_NAME: `Имя дилера`,
    DEALER_PHONE: `№ телефона дилера`,
    DEALER_POSTAL_CODE: `Почтовый индекс`,
    DEALER_RECOMMENDATIONS: `Рекомендации дилера`,
    DEALER_RECOMMENDATIONS_TAB: `Рекомендации дилера ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `Успешное рассмотрение дилером`,
    DEALER_SEARCH: `Поиск дилеров`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: `Введите название, город или аккаунт, чтобы найти дилеров.`,
    DEALER_STATE: `Регион дилера`,
    DEALER_SUBMISSION_WITH_CURRENCY: `Данные, предоставленные дилером ({currency})`,
    DEALER_TRANSFER_HISTORY: `Журнал перемещения техники между дилерами`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `Некоторые запросы на передачу успешно созданы. Обработайте оставшееся по отдельности.`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `Запрос на передачу дилера успешно отправлен в очередь`,
    DEALER_WARRANTY: `Гарантия дилера`,
    DEALERS: `Дилеры`,
    DEALERSHIP: `Дилерский центр`,
    DEBIT: `Дебет`,
    DEBIT_AMOUNT: `Сумма по дебету`,
    DEBIT_FOR_CLAIM_NUMBER: `Дебет для {claimNumber}`,
    DEBIT_REQUIRED: `Необходимая сумма по дебету`,
    DEBIT_REQUIRED_STATUS: `Статус необходимой суммы по дебету`,
    DEBIT_SUBMITTED_SUCCESSFULLY: `Успешная отправка суммы дебета`,
    DEBIT_TYPE: `Тип дебетования`,
    DEBITED: `Дебетований`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: `Дебетование по этой рекламации должно быть выполнено в ручном режиме.`,
    DECIMAL_FORMAT: `Десятичный формат`,
    DECISION_UPDATED: `Решение обновлено`,
    DECLINE: `Отклонить`,
    DEDUCTIBLE: `Вычеты`,
    DEERE_REMARKS: `Заметки John Deere`,
    DEFAULT_WARRANTY: `Гарантия по умолчанию`,
    DEL: `Удалить`,
    DELETE: `Удалить`,
    DELETE_ATTACHMENT: `Удалить приложение`,
    DELETE_CLAIM: `Удалить рекламацию`,
    DELETE_MACHINE_STATUS_UPDATE: `Удаление обновления состояния машины`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS: `Состояние машины: удаление успешно выполнено`,
    DELETE_REGISTRATION: `Удалить регистрацию`,
    DELETE_REGISTRATION_SUCCESS: `Регистрация успешно удалена.`,
    DELETED: `УДАЛЕНО`,
    DELETED_BY: `УДАЛЕНО (кем-то)`,
    DELIVERED: `Доставлено`,
    DELIVERED_IS_REQUIRED: `Требуется указать статус доставки.`,
    DELIVERY_DATE: `Дата поставки`,
    DELIVERY_DATE_REQUIRED: `Требуется дата поставки.`,
    DELIVERY_DATES: `Даты доставки`,
    DELIVERY_NO_DOCUMENTS: `Доставка без документов`,
    DEMO_RENTAL_BEGIN_DATE: `Дата начала демонстрации/аренды`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS: `Выбор дилеров и статуса`,
    DEMO_RENTAL_END_DATE: `Дата окончания демонстрации/аренды`,
    DEMO_RENTAL_HISTORY: `Журнал использования демонстрационной техники`,
    DENY: `Отказать`,
    DENY_AMOUNT_OF_USE: `Запрет на использование`,
    DENY_MACHINE_STATUS_UPDATE: `Отказ в обновлении состояния машины`,
    DENY_PIP_CODE_REQUEST: `Отклонить запрос кода программы PIP`,
    DESCENDING: `убывающий`,
    DESCRIPTION: `описание`,
    DESCRIPTION_OF_DAMAGE:`Описание повреждения`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE:`Описание события, в результате которого возникло повреждение`,
    DESELECT_ALL: `Отменить выбор всех`,
    DETAILS: `Сведения`,
    DIAGNOSTICS_COVERED: `Диагностика включена`,
    DIS_VSR: `Отображать сообщения`,
    DISPLAY: `Отобразить`,
    DISPLAY_CLAIM: `Отобразить Рекламация`,
    DISPLAY_CREDIT_MEMO: `Показать гарантийные выплаты`,
    DISPLAY_FORMAT: `Формат отображения`,
    DISPLAY_PRODUCT: `Отобразить продукт`,
    DISPLAY_TAG: `Отобразить метку`,
    DISTANCE: `Расстояние`,
    DISTANCE_FROM_CURRENT_DEALER: `Расстояние от текущего дилера`,
    DISTANCE_FROM_POTENTIAL_DEALER: `Расстояние от потенциального дилера`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `Расстояние от ответственной учетной записи`,
    DIVISION: `Подразделение`,
    DIVISION_SUMMARY: `Сводка по подразделению`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: `Сохранить внесенные вами изменения?`,
    DOES_NOT_CONTAIN: `Не содержит`,
    DOWNLOAD_TO_EXCEL: `Загрузить в Excel`,
    DOWNTIME: `Простой`,
    DOWNTIME_IS_REQUIRED: `Требуется указать срок простоя.`,
    DRAFT: `Сохранить как «Черновик»`,
    DTAC_CASE: `Формуляр DTAC`,
    DTAC_CASE_NUMBER: `Номер формуляра DTAC`,
    DTAC_SOLUTION: `Решение DTAC`,
    DUE_DATE: `Срок исполнения`,
    DUE_WITHIN_3_MONTHS: `К исполнению в течение 3месяцев`,
    DUPLICATE_PIN_PLATE: `Дублирующая табличка с номером PIN`,
    DUPLICATE_PIN_PLATE_REPORT: `Отчет о дублирующей табличке с номером PIN`,
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `Запрос на дублирование таблички с номером PIN обновлен`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `Запрос дубликата таблички с номером PIN успешно создан`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `Запрос дубликата таблички с номером PIN ({count})`,
    EDIT: `Правка`,
    EDIT_CUSTOMER: `Правка клиента`,
    EDIT_LAYOUT: `Правка макет`,
    EDIT_WITH_PARENTHESES: `(Правка)`,
    EFFECTIVE: `Действует, начиная с`,
    EFFECTIVE_DATE: `Дата вступления в силу`,
    EMAIL: `Эл. почта`,
    EMISSIONS_PART_SEARCH: `Поиск по запчастям в категории «Выхлопные газы»`,
    END_DATE: `Дата окончания`,
    END_USE: `Конечное использование`,
    END_USE_CODE: `Код конечного пользователя`,
    END_USE_CODE_REQUIRED: `Требуется указать код конечного использования.`,
    ENDS_WITH: `Заканчивается`,
    ENGLISH: `Aнглийский`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000: `Введите число от 0 до 1000.`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000: `Введите число в диапазоне от 0 до 10000.`,
    ENTER_A_NUMBER_FROM_1_TO_9999: `Введите число от 1 до 9999.`,
    ENTER_A_PART_NUMBER: `Введите артикул`,
    ENTER_COMMENTS_BEFORE_ACCEPTING: `Введите комментарии, прежде чем принять.`,
    ENTITY_ID: `Идентификатор организации`,
    EQUALS: `Равный`,
    ERROR: `ОШИБКА.`,
    ERROR_MESSAGE_TITLE: `Произошла ошибка.`,
    ERROR_MESSAGES: `Сообщения об ошибках`,
    ERROR_MESSAGES_TITLE: `Произошло несколько ошибок.`,
    ERROR_NETWORK_ISSUES: `Из-за сетевой ошибки некоторые данные не выгружены. Повторите попытку.`,
    ERROR_NO_DATA_TO_EXPORT: `Нет данных для экспорта`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION: `Ошибка при получении информации о клиенте`,
    ERROR_SAP: `Не удается установить соединение с сервером.  Если эта проблема возникнет снова, щелкните ссылку «Контакты» для получения помощи в ее разрешении.`,
    ERROR_SESSION: `Время сеанса истекло.  Обновите страницу, чтобы снова войти в систему.`,
    ERROR_UNHANDLED: `В системе возникла неожиданная ошибка.  Если эта проблема возникнет снова, воспользуйтесь функцией «Справка» или щелкните ссылку «Контакты» для получения помощи в ее разрешении.`,
    ERROR_UPLOADING_FILE: `Файл не был добавлен.`,
    ESTIMATED_BASIC_DATE: `Расчетная дата на основе стандартных дней`,
    ESTIMATED_BASIC_DAYS: `Расчетное число стандартных дней`,
    ESTIMATED_HOURS: `Расчетное количество моточасов`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: `Оценочные значения могут не включать время, соответствующее статусу демонстрации или еще не включенное в отчет.`,
    EXCEEDS_DEMO_THRESHOLD: `Превышает лимит для демонстраций`,
    EXCHANGE_RATE: `Валютный курс`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: `Исключенные ПИН-коды не включены в этот отчет.`,
    EXECUTE: `Выполнить`,
    EXPAND_ALL: `Развернуть все`,
    EXPECTED_FIRST_USE: `Ожидаемое первое использование`,
    EXPIRATION_DATE: `Дата истечения срока`,
    EXPIRED: `Срок действия истек`,
    EXPIRED_PART_REQUESTS: `Запросы на истекший период`,
    EXPIRED_PIPS: `Завершенные PIP`,
    EXPIRES: `Срок окончания`,
    EXPIRING_SOON: `Срок скоро истечет.`,
    EXPORT: `Экспорт`,
    EXTENDED_WARRANTY: `Расширенная гарантия`,
    FACTORY: `ЗАВОД`,
    FACTORY_DUPLICATE_PIN_PLATE: `Дублирующая табличка с номером PIN`,
    FACTORY_NAME: `Название завода`,
    FACTORY_USERS_TAB: `Дублирующая табличка с номером PIN ({count})`,
    FAILED: `Неисправность`,
    FAILED_AREA: `Зона неисправности`,
    FAILED_AREA_IS_REQUIRED: `Требуется указать зону неисправности.`,
    FAILED_DATE: `Дата неисправности`,
    FAILED_DATE_IS_REQUIRED: `Требуется указать дату неисправности.`,
    FAILED_MODE: `Режим неисправности`,
    FAILED_MODE_COMMENTS: `Комментарии для режима неисправности`,
    FAILED_PART: `Неисправная деталь`,
    FAILED_PART_DESCRIPTION: `Описание неисправной детали`,
    FAILED_PART_IS_A_REMAN_PART: `Неисправная деталь - деталь ReMan`,
    FAILED_PART_IS_REQUIRED: `Требуется указать неисправную деталь.`,
    FAILED_PART_SERIAL: `Серийный номер неисправной детали`,
    FAILED_PART_SERIAL_IS_REQUIRED: `Требуется указать серийный номер неисправной детали.`,
    FAILURE_DATE: `Дата неисправности`,
    FAILURE_INFORMATION: `Информация о неисправности`,
    FAILURE_MODE: `Характер неисправности`,
    FAILURE_MODE_IS_REQUIRED: `Требуется указать режим неисправности.`,
    FAILURE_PART: `Неисправная деталь`,
    FAILURE_PART_DESCRIPTION: `Описание неисправной запчасти`,
    FAILURE_PART_IS_REQUIRED: `Требуется неисправная запчасть.`,
    FAILURE_TO_RETURN_PARTS_WARNING: `Невозможность вернуть запрошенную часть (и) может привести к дебету.`,
    FAVORITES: `Избранные`,
    FILE_NAME: `Имя файла`,
    FILE_SIZE_IS_TOO_BIG: `Слишком большой размер файла (максимальный размер: 100МБ)`,
    FILE_SIZE_IS_TOO_BIG_CSV: `Слишком большой размер файла (максимальный размер: 1МБ)`,
    FILE_UPLOAD_MESSAGE: `Перетащите сюда файлы или щелкните здесь, чтобы добавить файлы (макс. размер: 100МБ).`,
    FILE_UPLOAD_MESSAGE_CSV: `Перетащите сюда файлы или щелкните здесь, чтобы добавить файлы (макс. размер: 1МБ).`,
    FILE_UPLOAD_MESSAGE_IMAGE: `Перетащите изображения здесь или нажмите здесь, чтобы добавить изображения (максимальный размер: 100МБ).`,
    FILE_UPLOAD_MESSAGE_SINGLE: `Перетащите сюда один файл или щелкните здесь, чтобы добавить его (максимальный размер— 100МБ)`,
    FILE_UPLOAD_UNABLE_TO_READ: `Системе не удалось прочитать файл.  Сравните его с шаблоном и повторите попытку.`,
    FILES: `Файлы`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `Результатов нет. Нажмите клавишу ВВОД, чтобы выполнить поиск по всем рекомендациям.`,
    FILTER_PLACEHOLDER: `Фильтр результатов поиска`,
    FILTER_WITH_ELLIPSIS: `Фильтр`,
    FILTERED_BY_COLUMN_ID: `Отфильтрован по {columnId}`,
    FIND_CUSTOMER: `Найти клиента`,
    FINNISH: `Финский`,
    FIRST_MAINTENANCE: `ПЕРВОЕ ОБСЛУЖИВАНИЕ`,
    FIRST_NAME: `Имя`,
    FIRST_NAME_IS_REQUIRED: `Требуется указать имя.`,
    FIRST_SHIP_TO_LOCATION: `Первый адрес доставки`,
    FIRST_USE: `Первое использование`,
    FISCAL_YEAR: `Отчетный год`,
    FLUID_SAMPLING_REQUIRED: `Необходимые отборы проб`,
    FORWARDED: `ПЕРЕНАПРАВЛЕНО`,
    FRENCH: `французский`,
    FRWRD: `Переслать`,
    FULL_DEBIT: `Полный дебет`,
    GENERAL: `Общая информация`,
    GERMAN: `Немецкий`,
    GET_MAINTENANCE_PLANS: `Получение планов техобслуживания`,
    GOODS_INSTALLATION_VAT: `Установка изделий— НДС`,
    GRACE_PERIOD: `Льготный период`,
    GREATER_THAN: `Больше чем `,
    GREATER_THAN_OR_EQUALS: `Больше чем или равный`,
    GROUP_COMPLETE: `Группа готова`,
    GST_PERCENTAGE: `GST Процент`,
    H_LIMIT: `Лимит часов`,
    HISTORY_TO_DISPLAY: `Отображать журнал (дней)`,
    HOME: `Дом`,
    HOUR_LIMIT: `Лимит часов`,
    HOURS: `Часов`,
    HOURS_ON_RENT: `Аренда, в часах`,
    HSN_SAC_CODE: `HSN/SAC Код`,
    IGST: `IGST`,
    IMPLEMENTS: `Рабочее оборудование`,
    IN_RANGE: `в диапазоне`,
    INCENTIVE: `стимул`,
    INCENTIVE_PROGRAMS: `Программы стимулирования`,
    INCLUDE_FULLY_COMPLETE: `Включить полностью завершенные ПИПы`,
    INDICATES_REQUIRED_FIELD: `Означает поле, обязательное для заполнения.`,
    INFO_MESSAGE_TITLE: `Оправлено системное уведомление:`,
    INFO_MESSAGES: `Информационные сообщения`,
    INFO_MESSAGES_TITLE: `Оправлено несколько системных уведомлений:`,
    INFO_REQUEST_STATUS_ERROR: `Информация готова к отправке с этим запросом.`,
    INFORMATION: `Информация`,
    INFORMATION_REQUEST: `Информационный запрос`,
    INFORMATION_REQUEST_STATUS: `Статус информационный запрос`,
    INPUT_PIN: `Ввод PIN`,
    INSPECTION: `Осмотр`,
    INSTALLED_BY: `Установил`,
    INSTALLED_BY_IS_REQUIRED: `Требуется указать того, кто установил.`,
    INTERNAL_DEERE_COMMENTS: `Внутренние комментарии John Deere`,
    INTERNAL_EQUIPMENT_NOTES: `Внутренние примечания к оборудованию`,
    INTERVAL_BEGINS: `Начало интервала`,
    INTERVAL_ENDS: `Конец интервала`,
    INTERVAL_TYPE_DESCRIPTION: `Описание типа интервала`,
    INVOICE_ACCOUNT: `Выставить счет аккаунту`,
    INVOICE_DEALER: `Дилер для выставления счета-фактуры`,
    INVOICE_NUMBER: `Номер счета-фактуры`,
    INVOICE_REQUEST: `Запрос счета-фактуры`,
    INVOICE_SENT: `Счет-фактура отправлен.`,
    INVOICE_UPDATED_SUCCESSFULLY: `Выставленный счет Успешно Обновлено`,
    INVOICED: `Счет выставлен`,
    INVOICED_TO: `Получатель счета`,
    IRC_PIN_MESSAGE: `Клиент является IRC и имеет право на дополнительное время в поездках и километраж в течение первых 500 часов или 12 месяцев владения машиной.`,
    ISSUED: `Оформлен`,
    ITALIAN: `Итальянский`,
    ITEM: `Вещь`,
    ITEM_NUMBER: `Номер элемента`,
    ITEM_NUMBER_IS_REQUIRED: `Требуется указать номер позиции.`,
    JDLINK_EXPIRES: `Истекает срок использования JDLink.`,
    JDP_COMMENTS: `Комментарии по JDP`,
    JDP_COMMENTS_IS_REQUIRED: `Требуется ввести комментарии JDP.`,
    JDP_CUSTOMER_RESOLUTION: `Решение клиента по JDP`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: `Требуются ввести решение клиента по JDP.`,
    JDP_REASON: `Причина JDP`,
    JDP_REASON_IS_REQUIRED: `Требуется указать причину JDP.`,
    LABOR: `Оплата труда`,
    LABOR_ADDITIVE: `Трудовые надбавки`,
    LABOR_ADDITIVE_COMPLETION_DETAIL: `Сведения о завершении Трудовые надбавки`,
    LABOR_ADDITIVE_PIPS: `PIP с Трудовые надбавки`,
    LABOR_ADDITIVE_TAB: `Трудовые надбавки ({count})`,
    LABOR_ADJUSTMENT: `Регулировка трудозатрат`,
    LABOR_COMMENTS: `Оплата труда Комментарии`,
    LABOR_HOURS: `Часы на раб.`,
    LABOR_ITEM_DETAILS: `Работа – {quantity} {unit} {description}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY: `Тариф на оплату труда успешно одобрен.`,
    LABOR_RATE_CHANGE_SUBMITTED: `Запрошено изменение тарифа на оплату работ`,
    LABOR_RATE_CHANGES_WITH_COUNT: `Изменение тарифа на оплату труда ({count})`,
    LABOR_RATE_CONFIRM: `Запрошенный тариф ниже текущего.  Вы действительно хотите отправить запрос?`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `Нормы в красном тексте указывают на увеличение более чем на 10% по сравнению с существующей нормой`,
    LABOR_RATE_HISTORY: `Предыдущие тарифы на оплату труда`,
    LABOR_RATE_REJECTED_SUCCESSFULLY: `Тариф на оплату труда успешно отклонен.`,
    LABOR_RATE_REQUESTS_STATUS: `Состояние запросов на оплату труда`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `Норма трудозатрат успешно возвращена`,
    LABOR_RATES: `Тариф на оплату труда`,
    LABOR_STATS: `Статистика по работе`,
    LABOR_TOTAL: `Всего по работе`,
    LABOR_TYPE: `Тип оплаты труда`,
    LABOR_VALUE: `Стоимость работ`,
    LABOR_WITH_COUNT: `Работа ({count})`,
    LANGUAGE: `Язык`,
    LAST_LOCATION_FROM: `Последнее местоположение от`,
    LAST_NAME: `Фамилия`,
    LAST_NAME_IS_REQUIRED: `Требуется указать фамилию.`,
    LAST_PERSONAL_CONTACT: `Последний личный контакт`,
    LAST_SEEN: `Последний просмотр`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `Последнее Отображение В Ответственной Учетной Записи`,
    LATEST: `Новейшие`,
    LAW_ENFORCEMENT_AGENCY_DETAILS: `Сведения о правоохранительном органе`,
    LAYOUT_CREATED_SUCCESSFULLY: `Макет успешно создан`,
    LAYOUT_DELETED_SUCCESSFULLY: `Макет удалён успешно`,
    LAYOUT_NAME: `Имя макета`,
    LAYOUT_UPDATED_SUCCESSFULLY: `Макет обновлен успешно`,
    LEAD_ACCOUNT: `Потенциальный клиент`,
    LEAD_DEALER: `Лучший дилер`,
    LESS_THAN: `Меньше чем`,
    LESS_THAN_OR_EQUALS: `Меньше чем или равный`,
    LICENSE_PLATE_NUMBER: `Номер на номерном знаке`,
    LIFETIME: `Срок службы`,
    LINE_ITEMS_EXPORT: `Экспорт позиций`,
    LIST: `Список`,
    LIST_TOTAL: `Итого по списку`,
    LOCATION: `Местонахождение`,
    LOCATION_DUE: `К исполнению дилерским центром`,
    LOCATIONS: `Местоположения`,
    LOCATIONS_WITH_COUNT: `Дилерские центры ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: `Машина уже зарегистрирована за этим клиентом.`,
    MACHINE_INFORMATION: `Сведения о машине`,
    MACHINE_MODEL_TYPE: `Модель/тип машины`,
    MACHINE_MODEL_TYPE_REQUIRED: `Требуется модель/тип машины`,
    MACHINE_STATUS: `Статус машины`,
    MACHINE_STATUS_UPDATE: `Обновление состояния машины`,
    MACHINE_STATUS_UPDATE_ACCEPTED: `Одобрено обновление статуса машины`,
    MACHINE_STATUS_UPDATE_DOCUMENT: `Документ об обновлении статуса машины`,
    MACHINE_STATUS_UPDATE_REJECTED: `Отказано в обновлении статуса машины`,
    MACHINE_STATUS_UPDATES_WITH_COUNT: `Обновления состояния машины ({count})`,
    MACHINE_TYPE: `Тип машины`,
    MACHINE_TYPE_IS_REQUIRED: `Требуется указать тип машины.`,
    MACHINE_USE: `Использование машины`,
    MAILING_RECIPIENT: `Получатель почты (имя и фамилия)`,
    MAILING_RECIPIENT_REQUIRED: `Требуется указать получателя почты`,
    MAINTENANCE: `Техобслуживание`,
    MAINTENANCE_PLAN: `Планы техобслуживания`,
    MAINTENANCE_PLAN_INFO: `Информация о планах техобслуживания`,
    MARK_AS_INPROCESS: `Пометить как «Выполняется»`,
    MARK_AS_REVIEW: `Пометить как проверенное`,
    MARKETING_INCENTIVE: `Маркетинг— Стимул`,
    MARKETING_JD_PROMISE: `Маркетинг— ОбязательствоJD`,
    MARKETING_MAINTENANCE_PLAN: `Маркетинг— План техобслуживания`,
    MARKETING_MASS_CHANNEL_FOLLOWUP: `Маркетинг— Последующие действия в розничной сети`,
    MARKETING_MASS_CHANNEL_PDI: `Маркетинг— Проверка PDI в розничной сети`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP: `Контакты с клиентами после продажи через розничную сеть`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: `Напоминаем: обязательно обратитесь к своему юрисконсульту, чтобы определить надлежащие процедуры #Запрета звонков#, действующие в вашем регионе и стране, прежде чем внедрять Программу последующих звонков, совершаемых после продажи.`,
    MASS_CHANNEL_PDI_CLAIM: `Проверка PDI в розничной сети`,
    MASTER_WARRANTY_TYPE: `Тип основной гарантии`,
    MATERIAL: `Номер материала`,
    MERCHANDISE: `Атрибутика`,
    MESSAGE: `Сообщение`,
    MESSAGES: `Сообщения`,
    METHOD_OF_CONTACT: `Способ контакта`,
    METHOD_OF_CONTACT_IS_REQUIRED: `Требуется указать способ контакта.`,
    METRIC: `Обязательные`,
    METRICS: `Показатели`,
    MILEAGE_LIMIT: `Лимит километража`,
    MOBILE_PHONE: `Мобильный телефон`,
    MODEL: `Модель`,
    MODEL_NUMBER: `Номер модели`,
    MODEL_YEAR: `Модельный год`,
    MODIFIED: `Изменено`,
    MONTH_TO_DATE: `С начала месяца`,
    MORE: `Больше`,
    MULTIPLE: `Несколько`,
    NAME: `Имя`,
    NET: `Чистый итог`,
    NET_AMOUNT: `Чистая сумма`,
    NET_AMOUNT_PAID: `Чистая сумма выплаты`,
    NET_TOTAL: `Всего нетто`,
    NEW: `НОВЫЙ`,
    NEW_ACCOUNT: `Новый счет`,
    NEW_CLAIM: `Новая рекламация`,
    NEW_CLAIM_VALUE: `Новое значение рекламации`,
    NEW_CUSTOMER_REQUIRED: `Требуется указать нового клиента.`,
    NEW_DEALER: `Новый дилер`,
    NEW_DEALER_DISTANCE: `Новое расстояние для дилеров`,
    NEW_DEALER_LOCATION: `Новое местоположение дилера`,
    NEW_LABOR_RATE: `Новый тариф на оплату труда`,
    NEW_REQUEST_ENTER_RATES: `Новый запрос - введите нормы`,
    NEW_STATUS: `Новый статус`,
    NEW_TRANSFER: `Новый трансфер`,
    NEW_TRANSFER_CREATED: `Создан новый трансфер`,
    NEW_VALUE: `Новое значение`,
    NO: `Нет`,
    NO_ACTIVE_WARRANTY: `Нет активных гарантий`,
    NO_AFFECTED_PINS: `Подходящие PIN, относящиеся к сфере ответственности вашего дилерского центра, отсутствуют.`,
    NO_AUTHORITY_TO_ACCESS: `У вас нет полномочий на доступ к JDWS. Пользователи дилерского центра, пожалуйста, свяжитесь со своим администратором профиля (DPA), чтобы убедиться в том, что центр управления и пользователи Deere связываются со службой поддержки с копией этой ошибки здесь`,
    NO_CLAIMS: `Рекламации отсутствуют.`,
    NO_CUSTOMER_ASSOCIATED: `Клиенты не ассоциированы.`,
    NO_CUSTOMER_SELECTED: `Не выбран ни один клиент`,
    NO_DEALER_INVOICES: `Счета, выставленные дилером, отсутствуют.`,
    NO_DEALERS_MAPPED: `Вашему идентификатору пользователя не сопоставлен ни один дилер. Обратитесь, пожалуйста, к системному администратору.`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: `Нет (Если повторный ввод в эксплуатацию невозможен, необходимо приложить фотографию машины в качестве свидетельства)`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: `Нет информации для этого продукта`,
    NO_LABOR_COVERAGE: `Нет покрытия трудозатрат`,
    NO_LOWERCASE: `Нет`,
    NO_MATCHING_DEALERS: `Дилеры, соответствующие тексту фильтра, отсутствуют.`,
    NO_OPEN_PART_REQUESTS: `Нет запросов к открытой части`,
    NO_OPEN_PIPS: `Нет открытых PIP`,
    NO_PARTS_RETURNED: `Возвращенных запчастей нет`,
    NO_PIP_PRODUCTS: `Продукция по PIP отсутствует.`,
    NO_PRODUCT_FOUND: `Продукция не найдена.`,
    NO_REQUIRED_ITEMS: `Обязательные пункты отсутствуют.`,
    NO_RESULTS: `Нет результатов`,
    NO_RESULTS_FOUND: `Результаты не найдены.`,
    NO_ROWS_TO_SHOW: `Нет строк для показа`,
    NO_SPECIAL_INSTRUCTIONS: `Специальные инструкции отсутствуют.`,
    NO_TRAVEL: `Без дорожных расходов`,
    NON_RECOVERABLE_TAXES: `Невозмещаемые налоги`,
    NON_TRACKED_PINS_HELP_TEXT: `Некоторые виды продукции не отображаются в   гарантийном списке, пока не будет выполнена регистрация. Ваши критерии поиска соответствуют большому ассортименту данной продукции.`,
    NON_TRAVEL: `Без поездок`,
    NONE: `Нет`,
    NORMAL: `НОРМА`,
    NOT_EQUAL: `Не равны`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`Уведомление успешно добавлено`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`Уведомление удалено успешно`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: `Последовательность уведомлений успешно обновлена`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`Уведомление обновлено успешно`,
    NOTIFICATIONS: `Уведомления`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES: `Число случаев диагностики`,
    NUMBER_OF_OPEN_PIPS: `{number} открытых программ PIP`,
    NUMBER_OF_REPAIR_OCCURRENCES: `Число случаев ремонта`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES: `Число случаев замены`,
    OLD_LABOR_RATE: `Старый тариф на оплату труда`,
    ON_SHELF: `На полке`,
    ON_SHELF_COST: `Затраты на хранение`,
    ONE_ITEM_MUST_BE_SELECTED: `Необходимо выбрать одну позицию.`,
    OPEN: `Открытые`,
    OPEN_PART_REQUESTS: `Открытые запросы на запчасти`,
    OPEN_PART_REQUESTS_WITH_COUNT: `Открытые запросы на запчасти ({count})`,
    OPEN_PIP_COUNT: `Открыть PIP Count`,
    OPEN_PIP_PROGRAMS: `Реестр программ PIP`,
    OPEN_PIPS: `Открытые PIP`,
    OPEN_PIPS_REPORT: `Отчет о текущих программах PIP`,
    OPEN_PIPS_TAB: `Открытые PIP ({count})`,
    OPEN_PIPS_Y_N: `Открытые программы по улучшению продукта (PIP) (Y/N)`,
    OPERATORS_COMPLAINT: `В чем состояла жалоба оператора?`,
    OPERATORS_COMPLAINT_IS_REQUIRED: `Требуется указать жалобу оператора.`,
    OPERATORS_MANUAL_NUMBER: `Номер руководства по эксплуатации`,
    OPTION_CODE: `Коды опций`,
    OPTION_CODE_CREATED_SUCCESSFULLY: `Код Опции Создан Успешно`,
    OPTION_CODE_DELETED_SUCCESSFULLY: `Код Опции Удален Успешно`,
    OPTION_CODES: `Коды опций`,
    OR: `или`,
    ORIGINAL_CLAIM_VALUE: `Исходное значение рекламации`,
    ORIGINAL_SUBMISSION_DATE: `Исходная дата отправки`,
    ORIGINALLY_SUBMITTED: `Изначально отправлено`,
    OTHER: `ДРУГИЕ`,
    OTHER_AMOUNT_OF_USE: `Другие Показатели Использования`,
    OTHER_AMOUNT_OF_USE_REQUIRED: `Требуются другие показатели использования.`,
    OTHER_CREDIT: `Другой кредит`,
    OTHER_CREDIT_1: `Другой кредит 1`,
    OTHER_CREDIT_2: `Другой кредит 2`,
    OTHER_CREDIT_3: `Другой кредит 3`,
    OTHER_CREDIT_ADJUSTMENT: `Регулировка прочих кредитов`,
    OTHER_CREDIT_ITEM_DETAILS: `Другой кредит - {description} ({quantity} {unit})`,
    OTHER_CREDIT_TOTAL: `Общая сумма других кредитов`,
    OTHER_CREDITS: `Другие кредиты`,
    OTHER_CREDITS_WITH_COUNT: `Другие кредиты ({count})`,
    OTHER_INSTRUCTIONS: `Другие инструкции`,
    OUTPUT_PIN: `Вывести PIN`,
    OVERDUE: `Просрочено`,
    OVERRIDE_ACCOUNT: `Блокировка учетной записи`,
    OVERRIDE_EFFECTIVE_DATE: `Дата вступления коррекции в действие`,
    OVERRIDE_SUGGESTED_ACCOUNT: `Блокировка рекомендуемой учетной записи`,
    OWNERSHIP_STATUS: `Статус собственности`,
    OWNERSHIP_STATUS_IS_REQUIRED: `Требуется указать статус собственности.`,
    PART: `Запчасть`,
    PART_1: `Запчасть 1`,
    PART_2: `Запчасть 2`,
    PART_3: `Запчасть 3`,
    PART_4: `Запчасть 4`,
    PART_5: `Запчасть 5`,
    PART_6: `Запчасть 6`,
    PART_7: `Запчасть 7`,
    PART_8: `Запчасть 8`,
    PART_9: `Запчасть 9`,
    PART_10: `Запчасть 10`,
    PART_AMONT_OF_USE: `Показатели использования запчасти`,
    PART_FAMILY: `Семейство запчасти`,
    PART_ITEM_DETAILS: `Запчасти – {quantity} {description} Артикул {partNumber}`,
    PART_NUMBER: `Артикул`,
    PART_REQUEST: `Запрос на запчасти`,
    PART_REQUEST_NUMBER: `Запрос на запчасти {rgaNumber}`,
    PART_REQUEST_STATUS: `Статус запроса на запчасти`,
    PART_REQUESTS: `Запросы на запчасти`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: `Введите номер рекламации; не менее 4символов.`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: `При поиске рекламации следует указать не менее 4 символов.`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: `При поиске по номеру формуляра DTAC следует указать его полный номер; не менее 4 символов.`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: `Введите полный номер формуляра DTAC.`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: `При поиске по артикулу должен следует указать не менее 4 символов.`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: `Введите номер запчасти; не менее 4 символов.`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: `При поиске по номеру запроса на запчасть следует указать не менее 4 символов.`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: `Введите номер запроса на запчасть; не менее 4 символов.`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR: `При поиске по номеру PIN следует указать не менее 4 символов.`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: `Введите номер PIN; не менее 4 символов.`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: `При поиске по заказ-наряду следует указать заказ-наряд полностью; не менее 2 символов.`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: `Введите полный заказ-наряд.`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY: `Запрос на запчасть успешно обновлен.`,
    PART_RETURN: `Возврат запчасти`,
    PART_RETURNS: `Возвраты запчастей`,
    PART_SERIAL_NUMBER: `Серийный номер детали`,
    PART_SERIAL_NUMBER_IS_REQUIRED: `Требуется указать серийный номер запчасти.`,
    PART_TOTAL: `Итого по запчастям`,
    PART_TYPE: `Тип запчасти`,
    PART_USE: `Использование запчасти`,
    PART_VALUE: `Стоимость запчастей`,
    PARTIAL_DEBIT: `Частичный дебет`,
    PARTICIPANT: `Участник`,
    PARTS: `ЗАПЧАСТИ`,
    PARTS_ADDITIVE: `Дополнительные запчасти`,
    PARTS_ADJUSTMENT:`Регулировка деталей`,
    PARTS_COVERAGE_SEARCH: `Поиск покрытия для запчасти`,
    PARTS_TEMPLATE: `Шаблон деталей`,
    PARTS_USE: `Использование запчасти`,
    PARTS_USE_IS_REQUIRED: `Требуется указать использование запчасти.`,
    PARTS_WITH_COUNT: `Запчасти ({count})`,
    PARTS_WITH_PARENTHESES: `Запчасти`,
    PAST_DUE: `Просроченные`,
    PAYER_ACCOUNT: `Счет плательщика`,
    PC_LIMIT:`Предел рулона`,
    PERCENT_COMPLETE: `Процент завершения`,
    PERCENTAGE: `Процент`,
    PERCENTAGE_DEBIT: `Процент дебетования`,
    PERCENTAGE_SYMBOL: `{percentage}%`,
    PERCENTAGE_TO_DEBIT: `Процент до дебета`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES: `Машины, полностью выведенные из строя`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: `Для машин, полностью выведенных из эксплуатации, приложите фотографию машины, чтобы убедиться в том, что в будущем машина не может быть отремонтирована, отремонтирована или использована. На машины, которые полностью не обслуживаются, никакие PIP-программы не распространяются.`,
    PERSON_RESPONSIBLE: `Ответственное лицо`,
    PHONE: `ТЕЛЕФОН`,
    PHONE_REQUIRED: `Требуется телефон`,
    PICTURE: `Фотография`,
    PICTURE_REQUEST: `Запрос изображения`,
    PICTURE_REQUEST_STATUS: `Статус запроса изображения`,
    PICTURE_REQUEST_STATUS_ERROR: `Прикрепленные файлы готовы к отправке с этим запросом.`,
    PIN: `серийному номеру PIN`,
    PIN_CREATED_SUCCESSFULLY: `PIN успешно создан.`,
    PIN_CROSS_REFERENCE: `Перекрестные ссылки для номеров PIN`,
    PIN_INVALID: `Неверно указан PIN.`,
    PIN_IS_REQUIRED: `Требуется указать номер PIN.`,
    PIN_REQUIRED: `Требуется указать PIN.`,
    PIN_SEARCH: `Поиск контактов`,
    PIN_SEARCH_INFORMATION: `Информация поиска контактов`,
    PIN_TRANSFER_INFORMATION: `Информация о передаче контактов`,
    PINS: `Номера PIN`,
    PINS_NOT_REGISTERED: `Не прошедшие регистрацию серийные номера`,
    PIP: `PIP`,
    PIP_CODE: `Код PIP`,
    PIP_CODE_CREATED_SUCCESSFULLY: `Запрос кода программы PIP успешно создан.`,
    PIP_CODE_REQUEST: `Запрос кода программы усовершенствования продукции (PIP)`,
    PIP_CODE_REQUEST_APPROVED: `Запрос кода программы PIP одобрен`,
    PIP_CODE_REQUEST_REJECTED: `Запрос кода программы PIP отклонен`,
    PIP_CODE_REQUESTS_WITH_COUNT: `Запросы кодов программ PIP ({count})`,
    PIP_COMPLETION_STATUS: `Состояние выполнения PIP`,
    PIP_DETAILS: `Сведения о PIP`,
    PIP_HISTORY: `Журнал программ PIP`,
    PIP_ID: `Номер PIP`,
    PIP_NUMBER: `Номер PIP`,
    PIP_PROGRAM: `Программа PIP`,
    PIP_PROGRAM_IS_REQUIRED: `Требуется указать программу PIP.`,
    PIP_PROGRAMS: `Программы PIP`,
    PIP_SEARCH: `Поиск PIP`,
    PIP_STATUS: `Статус PIP`,
    PIP_TYPE: `Тип PIP`,
    PIP_TYPES: `Тип PIP`,
    PIPS: `Программы PIP`,
    PIPS_UNPAID_LABOR_ADDITIVE: `Неоплаченные дополнительные работы по PIP`,
    PLAN_DESCRIPTION: `Описание плана`,
    PLAN_END_DATE: `Дата окончания плана`,
    PLAN_ENDS: `Конец действия плана`,
    PLAN_NAME: `Имя плана`,
    PLAN_NAME_IS_REQUIRED: `Требуется указать название плана.`,
    PLAN_NAMES: `Имена планов`,
    PLAN_START_DATE: `Дата начала плана`,
    PLAN_STARTS: `Начало действия плана`,
    PLANNED_BY: `Запланирован`,
    PLANT: `Завод`,
    PLATE_REQUEST_INFORMATION: `Информация о запросе таблички`,
    PLEASE_SELECT_A_LEAD_ACCOUNT: `Выберите, пожалуйста, основную учетную запись.`,
    PLEASE_SELECT_CLAIM_TYPE: `Пожалуйста, выберите тип рекламации.`,
    POLISH: `Польский`,
    PORTUGUESE: `португальский`,
    POSTAGE_DELIVERY_DATE: `Дата доставки посылки`,
    POSTAL_CODE: `Почтовый индекс`,
    POSTAL_CODE_REQUIRED: `mТребуется почтовый индекс`,
    POSTAL_TRACKING_NUMBER: `Почтовый регистрационный номер`,
    POTENTIAL_RESPONSIBLE_DEALER: `Потенциальный ответственный дилер`,
    PRE_DELIVERY_INSPECTION: `Предпоставочная проверка`,
    PREFERRED_THEME: `Предпочтительная тема`,
    PREPARE_AUDIT: `Подготовить аудит`,
    PREPARED: `Подготовлено`,
    PREPARING_AUDIT_FOR_WITH_DEALER: `Готовится аудит для {dealer}`,
    PREVIOUS_AMOUNT_OF_USE: `Предыдущие Показатели Использования`,
    PREVIOUS_INVOICE_NUMBER: `Номер предыдущего счета-фактуры`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: `Требуется указать номер предыдущего счета-фактуры.`,
    PREVIOUS_MONTH: `Прошлый месяц`,
    PRICE: `Цена`,
    PRICING_SUMMARY: `Сводка по ценам`,
    PRIMARY_ACTION: `Основное действие`,
    PRIMARY_LANGUAGE: `Основной язык`,
    PRINT: `Печать`,
    PRINT_CLAIM: `Печать рекламации`,
    PRINT_REGISTRATION_FORM: `Распечатать регистрационную форму`,
    PRINT_REGISTRATION_FORM_MESSAGE: `Продукт зарегистрирован для первого владельца. Хотели бы Вы распечатать регистрационную форму сейчас?`,
    PRINT_TO_PDF: `Печать PDF`,
    PRIORITY: `Приоритет`,
    PRNT_CLM: `Отобразить рекламацию`,
    PROCESS_DATE: `Дата обработки`,
    PROCESSED: `Обработано`,
    PROCESSED_PART_REQUESTS: `Запросы обрабатываемых деталей`,
    PROCESSING_STATUS: `Статус обработки`,
    PROCESSING_STATUS_DESCRIPTION: `Описание статуса обработки`,
    PRODUCT_DETAILS: `Сведения о продукции`,
    PRODUCT_HIERARCHY: `Иерархия продуктов`,
    PRODUCT_INFORMATION: `Информация о машине`,
    PRODUCT_REGISTERED: `Машина зарегистрирована`,
    PRODUCT_REGISTRATION: `Регистрация продукции`,
    PRODUCT_REGISTRATION_PENDED: `Регистрация машины находится на рассмотрении.`,
    PRODUCT_TRACKING: `Отслеживание машин`,
    PRODUCTS: `Продукция`,
    PRODUCTS_BY_CUSTOMER: `продукты клиентом`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: `Исторические PIN-коды могут отсутствовать в результатах поиска из-за временной проблемы подключения к системе`,
    PRODUCTS_WITH_COUNT: `Продукция ({count})`,
    PROGRAM: `программа`,
    PROGRAM_DESCRIPTION: `Описание программы`,
    PROGRAM_IS_REQUIRED: `Название программы обязательно.`,
    PROGRAM_NAME: `Название программы`,
    PROGRAM_NAME_IS_REQUIRED: `Название программы обязательно.`,
    PROGRAM_NUMBER: `Номер программы`,
    PRT: `PRT`,
    PRTS: `PRT`,
    PURCHASE_INFO: `Информация о покупке`,
    PURCHASE_ORDER: `Заказ на покупку`,
    PURCHASE_ORDER_IS_REQUIRED: `Требуется указать заказ на покупку.`,
    PURCHASER_TYPE: `Тип покупателя`,
    PURCHASER_TYPE_REQUIRED: `Требуется указать тип покупателя.`,
    PUSH_XML: `Переотправить XML`,
    QTY: `Кол-во`,
    QUALIFY_FOR_EMISSIONS: `Подходит под категорию «Выхлопные газы»`,
    QUANTITY: `Количество`,
    QUANTITY_1: `Количество 1`,
    QUANTITY_2: `Количество 2`,
    QUANTITY_3: `Количество 3`,
    QUANTITY_4: `Количество 4`,
    QUANTITY_5: `Количество 5`,
    QUANTITY_6: `Количество 6`,
    QUANTITY_7: `Количество 7`,
    QUANTITY_8: `Количество 8`,
    QUANTITY_9: `Количество 9`,
    QUANTITY_10: `Количество 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS: `Запрос должен содержать не менее 3 символов.`,
    QUEST_DESC: `Сомнительное описание`,
    QUESTIONABLE_PART: `Сомнительная деталь`,
    QUEUED: `В очереди`,
    READING_DATE: `Дата считывания`,
    REASON: `Причина`,
    REASON_EVENT_NUMBER: `Номер события причины`,
    REASON_FOR_CHANGE: `Причина изменения`,
    REASON_FOR_DEBIT: `Причина для дебета`,
    REASON_FOR_MISSING_PLATE: `Причина отсутствия таблички`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `Причина отсутствия требуемой таблички`,
    REASON_FOR_OVERRIDE: `Причина коррекции`,
    REASON_FOR_REFUSAL: `Причина для отказа`,
    REASON_FOR_RETURN: `Причина возврата`,
    REASON_FOR_RETURN_IS_REQUIRED: `Требуется указать причину возврата.`,
    REASON_FOR_TRANSFER: `Причина для трансфера`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: `Причина для трансфера должна содержать буквенно-цифровые символы.`,
    REASON_FOR_TRANSFER_REJECTION: `Причина отклонения переноса`,
    RECIPIENT_DEALER_OR_TCSM: `Получатель (дилер или TCSM)`,
    RECIPIENT_MAILING: `Получатель почты`,
    RECOMMENDATION: `Рекомендация`,
    RECOMMENDATION_DATE: `Дата рекомендации`,
    RECOMMENDED_ACCOUNT: `Рекомендуемая учетная запись`,
    RECONCILE: `Удовлетворить`,
    RECONCILE_CLAIM: `Удовлетворить рекламацию`,
    RECONCILED: `СОГЛАСОВАНО`,
    RECORD_AUDIT: `Регистрация результатов аудита`,
    RECORD_AUDIT_FOR: `Регистрация результатов аудита для {dealer}`,
    RECORDS_FOUND: `{countToDisplay} {count, plural, one {запись найдена} other {запис. найдено}}`,
    RECOVERABLE_TAXES: `Возмещаемые налоги`,
    RECOVERED: `Возвращено`,
    RECOVERED_WITH_MISSED_ADDITIVES: `Возвращено с недостающими надбавками`,
    RECOVERED_WITHOUT_ADDITIVES: `Возвращено без надбавок`,
    RECOVERY: `Восстановление`,
    RED_MUST_BE_LESS_THAN_YELLOW: `Значение красного индикатора должно быть меньше значения желтого индикатора.`,
    REFERENCE_1: `Справка1`,
    REFERENCE_2: `Ссылка 2`,
    REFERENCE_INFORMATION: `Справочная информация`,
    REFERENCE_NUMBER1: `Справочный номер 1`,
    REFERENCE_NUMBER2: `Справочный номер 2`,
    REGION: `Регион`,
    REGISTER: `Регистрация`,
    REGISTER_A_PRODUCT_BY_PIN: `Зарегистрировать продукцию по номеру PIN`,
    REGISTER_A_PRODUCT_TO_ADD: `Register Product to add to the Warranty System`,
    REGISTER_ANOTHER_PRODUCT: `Регистрация другого продукта`,
    REGISTER_PRODUCT: `Регистрация машин`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER: `Register Product and Register Another`,
    REGISTERED: `зарегистрированной технике`,
    REGISTRATION: `Регистрация`,
    REGISTRATION_DATE: `Дата регистрации`,
    REGISTRATION_DATES: `Даты регистрации`,
    REGISTRATION_FORM: `Регистрационная форма`,
    REGISTRATION_HISTORY: `Журнал регистрации`,
    REGISTRATION_NOT_ALLOWED: `Регистрация для данной продукции не разрешена.`,
    REGISTRATION_REVIEW: `Анализ регистрации`,
    REGISTRATION_REVIEW_TAB: `Анализ регистрации ({count})`,
    REGISTRATION_STATUS: `Статус регистрации`,
    REGISTRATION_STATUS_CANNOT_BE_NEW: `Статус регистрации нельзя указывать  как Новая.`,
    REGISTRATION_STATUS_REQUIRED: `Требуется указать статус регистрации.`,
    REGISTRATION_SUCCESS: `Регистрация успешно выполнена.`,
    REGISTRATION_TYPE: `Тип регистрации`,
    REGISTRATION_TYPE_CANNOT_BE_NEW: `Тип регистрации нельзя указывать как Новая.`,
    REGISTRATION_TYPE_REQUIRED: `Требуется указать тип регистрации.`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `Регистрация успешно обновлена`,
    REGISTRATIONS_REVIEW: `Анализ регистрации`,
    REIMBURSED: `Возмещено`,
    REIMBURSED_AMOUNT: `Возмещенная сумма`,
    REIMBURSED_PERCENTAGE: `Возмещенный процент`,
    REIMBURSED_PERCENTAGE_INDICATOR: `Индикатор возмещенного процента`,
    REIMBURSEMENT_DETAILS: `Сведения о возмещении`,
    REIMBURSEMENT_PERCENTAGE: `Возмещение в процентах`,
    REIMBURSEMENT_SUMMARY: `Всего на возмещение`,
    REJECT: `Отклонить`,
    REJECT_LABOR_RATE: `Отклонить тариф на оплату труда`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM: `Отклонить рекламацию по специальному решению`,
    REJECTED: `ОТКЛОНЕНО`,
    REJECTED_APPEAL: `ОТКЛОНЕННАЯ ЖАЛОБА`,
    RELATIONSHIP: `Взаимоотношения`,
    RELATIONSHIP_IS_REQUIRED: `Требуется указать данные о взаимоотношениях.`,
    REMOVE_FILTER: `Удаление фильтра`,
    REMOVE_FROM_AUDIT: `Удалить из аудита`,
    REMOVE_LAYOUT: `Удалить макет`,
    RENTAL_PINS: `Арендные номера PIN`,
    REPAIR_DATE: `Дата ремонта`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: `Дата ремонта не должна предшествовать дате неисправности.`,
    REPAIR_NUMBER: `Номеру ремонта`,
    REPAIR_NUMBER_IS_REQUIRED: `Требуется указать номер ремонта.`,
    REPAIR_REPLACE_INDICATOR: `Индикатор ремонта/замены`,
    REPAIRED: `Отремонтировано`,
    REPAIRED_DATE: `Дата ремонта`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: `Дата ремонта не может предшествовать дате неисправности.`,
    REPAIRED_DATE_IS_REQUIRED: `Требуется указать дату ремонта.`,
    REPORT_DATE: `Дата отчета`,
    REPORT_NUMBER: `Номер регистрации`,
    REPORTS: `Отчеты`,
    REQ_ADDL: `Скорректировать кредит`,
    REQUEST: `Запрос`,
    REQUEST_DATE: `Дата запроса`,
    REQUEST_DETAILS: `Детали запроса`,
    REQUEST_DUPLICATE_PIN_PLATE: `Запрос дубликата таблички с номером PIN`,
    REQUEST_FORM: `Форма запроса`,
    REQUEST_PIP_CODE: `Запрос кода PIP`,
    REQUEST_STATUS: `Статус запрос`,
    REQUEST_SUBMITTED: `Запрос отправлен`,
    REQUEST_TYPE: `тип запроса`,
    REQUEST_UPDATED_SUCCESSFULLY: `Запрос успешно завершен`,
    REQUEST_WARRANTY_CLAIM_DEBIT: `Дебет, запрошенный по гарантийной рекламации`,
    REQUESTED: `отправителю запроса`,
    REQUESTED_BY: `Отправитель запроса`,
    REQUESTED_DATE: `Дата запроса`,
    REQUESTED_DATES: `Запрошенные даты`,
    REQUESTED_DIAGNOSTIC_AMOUNT: `Запрашиваемая Сумма диагностики`,
    REQUESTED_DIAGNOSTIC_HOURS: `Запрашиваемые Часов диагностики`,
    REQUESTED_LABOR_AMOUNT: `Запрошенная сумма за работу`,
    REQUESTED_LABOR_HOURS: `Запрашиваемые рабочие часы`,
    REQUESTED_OTHER_CREDITS: `Запрошено по другим выплатам`,
    REQUESTED_PARTS: `Запрошено по запчастям`,
    REQUESTED_REPAIR_AMOUNT: `Запрашиваемая Сумма ремонта`,
    REQUESTED_REPAIR_HOURS: `Запрашиваемые Часов ремонта`,
    REQUESTED_TRAVEL_TOTAL: `Всего запрошено по дорожным расходам`,
    REQUESTER_TCSM: `Запрашивающее устройство (TCSM)`,
    REQUESTER_TCSM_REQUIRED: `Требуется запрос (TCSM)`,
    REQUIRED: `требуется`,
    REQUIRED_CRITERIA: `Запрошенные критерии`,
    REQUIRED_ITEMS: `Обязательные пункты`,
    RESEND_XML: `Переотправить XML`,
    RESET: `Сброс`,
    RESPONDENT_INFORMATION: `Информация о респонденте`,
    RESPONSIBILITY_OF: `Ответственный`,
    RESPONSIBLE_ACCOUNT: `Ответственный аккаунт`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED: `Требуется указать ответственный аккаунт.`,
    RESPONSIBLE_DEALER: `Сортировать по Ответственному дилеру`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `Показаны первые 100 результатов. Загрузите для получения полных результатов`,
    RET: `Возврат`,
    RETAIL_INSTALL: `Продажа/установка`,
    RETAIL_INSTALL_DATE: `Дата розничной продажи/установки`,
    RETAIL_INSTALL_IS_REQUIRED: `Требуется указать данные о продаже/установке.`,
    RETAILER_NAME: `Имя продавца`,
    RETAILER_NAME_IS_REQUIRED: `Требуется указать имя продавца.`,
    RETRY: `повторить попытку`,
    RETURN: `Возврат`,
    RETURN_LABOR_RATE: `Возвратная ставка трудозатрат`,
    RETURN_REQUEST: `Запрос возврата`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM: `Вернуть рекламацию по специальному решению`,
    RETURN_STATUS: `Статус возврата`,
    RETURNED: `ВОЗВРАЩЕНО`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: `Дата возврата не может предшествовать дате доставки.`,
    RETURNED_DATE_IS_REQUIRED: `Требуется указать дату возврата.`,
    RETURNED_MACHINE_STATUS_UPDATE: `Обновление состояния возвращенной машины`,
    REVIEW_DEALER_RECOMMENDATIONS: `Пометить номера PIN для проверки?`,
    REVISE: `Исправить`,
    REVISED: `ИЗМЕНЕНО`,
    ROLLING_12_CREDIT_AMOUNT: `Сумма кредита за 12месяцев подряд`,
    ROLLING_12_MONTHS: `За 12 месяцев подряд`,
    RUN_REPORT: `Создать отчет`,
    RUSSIAN: `русский`,
    SAP_DOWN_WARNING: `Функциональность системы гарантийного обслуживания нарушена. Мы работаем над тем, чтобы исправить это как можно быстрее. Обновите браузер, чтобы проверить доступность системы.`,
    SAVE: `Сохранить`,
    SAVE_AS_DRAFT: `Сохранить как «Черновик»`,
    SAVE_AS_NEW_LAYOUT: `Сохранить как новый макет`,
    SAVE_AUDIT: `Сохранить аудит`,
    SAVE_CHANGES: `Сохранить изменения`,
    SAVE_TO_VALIDATE: `Сохранить, чтобы подтвердить`,
    SAVE_VALD: `Сохранить и подтвердить`,
    SAVE_VALIDATE: `Сохранить и подтвердить`,
    SEARCH: `Поиск`,
    SEARCH_BOX_PLACEHOLDER: `Введите PIN, серийный №, № рекламации, формуляр DTAC или имя клиента.`,
    SEARCH_BY_CLAIM_TYPE: `Введите тип рекламации полностью.`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: `При поиске рекламации ее тип следует указать полностью; от 4 до 9 символов.`,
    SEARCH_BY_FAILURE_PART_NUMBER: `Введите полный артикул неисправной детали.`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: `При поиске рекламации артикул неисправной детали следует указать полностью; не менее 4 символов.`,
    SEARCH_BY_WORK_ORDER: `Введите заказ-наряд; не менее 2 символов.`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: `При поиске по заказ-наряду следует указать от не менее 2 символов.`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: `Введите полный номер рекламации.`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: `Поиск рекламаций следует выполнять по полному номеру рекламации, состоящему из 4-9знаков.`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: `Введите полный серийный номер компонента.`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: `При поиске компонента следует указать полный серийный номер; не менее 1символа.`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: `Введите PIN-код`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: `Введите полный номер модели.`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: `Поиск моделей следует выполнять по полному номеру модели, состоящему из 3-12знаков.`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: `Введите номер PIN; не менее 6 символов.`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: `При поиске по номеру PIN следует указать от 6 до 17 символов.`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: `Введите номер PIP, включающий не менее 4знаков.`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: `При поиске по номерам PIP следует вводить 4-12знаков.`,
    SEARCH_RESULTS_TAB: `Результаты поиска ({count})`,
    SECOND_SHIP_TO_LOCATION: `Второй адрес доставки`,
    SELECT: `Выбрать`,
    SELECT_A_RANGE: `Выберите диапазон`,
    SELECT_ALL: `Выбрать все`,
    SELECT_AUTO_SUBMIT: `Выбор автоотправки`,
    SELECT_BRANCH: `Выбор филиала`,
    SELECT_CLAIM_TYPE: `Выбор типа рекламации`,
    SELECT_COLUMNS: `Выберите столбцы`,
    SELECT_COUNTRY: `Выберите страну`,
    SELECT_CSV_SEPARATOR: `Выберите Сепаратор CSV`,
    SELECT_DATE_FORMAT: `Выбор формата даты`,
    SELECT_DEALERS_AND_STATUS: `Выбор дилеров и статуса`,
    SELECT_DECIMAL_FORMAT: `Выбор десятичного формата`,
    SELECT_DISPLAY_FORMAT: `Выбор формата отображения`,
    SELECT_FACTORY: `Выбор завода`,
    SELECT_LANGUAGE: `Выбор языка`,
    SELECT_LAYOUT: `Выбор макет`,
    SELECT_PIP_CODE: `Выбрать код программы усовершенствования продукции (PIP)`,
    SELECT_PLAN_NAMES: `Выбор имен планов`,
    SELECT_SERVICE_INTERVAL_TYPES: `Выбор типов интервалов техобслуживания`,
    SELECT_SORT_BY: `Выбор Сортировать по`,
    SELECT_SORT_DIRECTION: `Выбор Сортировка`,
    SELECT_STATE: `Выбор штата`,
    SELECT_STATUS: `Выбор статуса`,
    SELECT_TERRITORY: `Выбрать территорию`,
    SELECT_THEME: `Выбор темы`,
    SELECT_TIME_ZONE: `Выбор часового пояса`,
    SELECT_VALUES_TO_APPROVE: `Выберите значения для утверждения.`,
    SELECTED_COLUMNDS: `Выбранные столбцы`,
    SELECTED_FOR_AUDIT: `Выбрано для аудита`,
    SELECTED_FOR_AUDIT_VSR: `Для ознакомления с требуемой документацией по аудиту и вложениями, необходимыми для этой претензии, см. решение DTAC 221475`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: `При выборе нескольких аккаунтов и типов гарантий может снизиться производительность системы.`,
    SEND: `Отправить`,
    SERIAL_NUMBER: `Серийный номер`,
    SERIAL_NUMBER_INVOICE_NUMBER: `Серийный номер / Номер счета-фактуры`,
    SERVER_TOOK_TOO_LONG_TO_REPLY: `Сервер слишком долго не отвечал, поэтому запрос был отменен. Пожалуйста, введите более конкретный запрос или повторите попытку позже.`,
    SERVICE_DATE_IS_REQUIRED: `Требуется указать дату техобслуживания.`,
    SERVICE_INTERVAL: `Интервал техобслуживания`,
    SERVICE_INTERVAL_BEGIN_DATE: `Дата начала интервала техобслуживания`,
    SERVICE_INTERVAL_END_DATE: `Дата окончания интервала техобслуживания`,
    SERVICE_INTERVAL_IS_REQUIRED: `Требуется указать межсервисный интервал.`,
    SERVICE_INTERVAL_NUMBER: `Номер интервала техобслуживания`,
    SERVICE_INTERVAL_STATUS: `Статус интервала техобслуживания`,
    SERVICE_INTERVAL_TYPE: `Тип интервала техобслуживания`,
    SERVICE_INTERVAL_TYPES: `Типы интервалов техобслуживания`,
    SERVICE_PART: `Сервисная часть`,
    SERVICE_UNAVAILABLE: `Служба недоступна`,
    SERVICED: `Обслужено`,
    SERVICED_DATE_IS_REQUIRED: `Дата обслуживания обязательна.`,
    SERVICED_IS_REQUIRED: `Дата обслуживания обязательна.`,
    SET_AS_DEFAULT: `Установить по умолчанию`,
    SETTINGS: `Мои настройки`,
    SETTLED: `Расчет произведен`,
    SETTLEMENT_NO_REGISTRATION: `Расчет, нет регистрации`,
    SETUP: `Настройка`,
    SETUP_DATE_IS_REQUIRED: `Требуется указать дату настройки.`,
    SETUP_IS_REQUIRED: `Требуется выполнить настройку.`,
    SGST_UTGST: `SGST/UTGST`,
    SHIP_TO: `Доставка`,
    SHIPPED: `Отгружено`,
    SHIPPING_ID: `Код доставки`,
    SHIPPING_ID_REQUIRED: `Требуется код доставки`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `Информация по транспортировке/специальные инструкции`,
    SHIPPING_INSTRUCTIONS: `Инструкции по отгрузке`,
    SHORT_TEXT: `Краткий текст`,
    SHORT_TEXT_IS_REQUIRED: `Требуется короткий текст`,
    SHOW_ALL: `Показать все ({count})`,
    SHOW_EXCLUDED: `Отобразить исключенные`,
    SHOW_MORE: `Показать больше`,
    SHOW_MORE_GROUPS: `Отобразить еще {countToDisplay} {count, plural, one {группу} other {групп(ы)}}`,
    SHOW_RED_IF_LESS_THAN: `Отображать красным, если меньше`,
    SHOW_REIMBURSED_AMOUNT: `Показать возмещенную сумму`,
    SHOW_REIMBURSED_PERCENTAGE: `Показать возмещенный процент`,
    SHOW_YELLOW_IF_LESS_THAN: `Отображать желтым, если меньше`,
    SIGN_IN_REQUIRED: `Требуется выполнить вход`,
    SIGN_OUT: `Выход`,
    SKIP_AUDIT: `Пропустить Аудит`,
    SKIP_AUDIT_SUCCESS: `Аудит пропущен, а срок выполнения - в будущем.`,
    SOME_PARTS_RETURNED: `Возвращено несколько запчастей`,
    SORT_BY: `Сортировать по`,
    SPANISH: `испанский`,
    SPECIAL_ALLOWANCE: `СПЕЦИАЛЬНОЕ РЕШЕНИЕ`,
    SPECIAL_ALLOWANCE_CALCULATION: `Расчет по специальному решению`,
    SPECIAL_ALLOWANCE_CLAIM: `Рекламация по специальному решению`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS: `Статус рекламации по специальному решению`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: `Статус рекламации по специальному решению`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: `Статус рекламации по специальному решению обновлен`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID: `Рекламация по специальному решению — {claimNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: `Рекламации по специальным решениям ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS: `Вклады по специальному решению`,
    SPECIAL_ALLOWANCE_DESCRIPTION: `Описание специального решения`,
    SPECIAL_ALLOWANCE_TYPE: `Тип Специального Решения`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: `Требуется указать тип специального решения.`,
    SPECIAL_INSTRUCTIONS: `Специальные инструкции`,
    SPG: `SPG`,
    SPGS: `Цены на услуги`,
    STANDARD_VIEW: `Общий вид`,
    START_AMOUNT_OF_USE: `Показатели использования на начало`,
    STARTS: `Начало`,
    STARTS_WITH: `начинается с`,
    STATE: `Регион`,
    STATE_PROVINCE: `Штат/провинция`,
    STATE_PROVINCE_REQUIRED: `Требуемый штат/область`,
    STATUS: `Статус`,
    STATUS_CHANGE_REQUEST: `Запрос на изменение статуса`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: `Запрос на изменение статуса успешно создан.`,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY: `Запрос состояния машины успешно обновлен`,
    STATUS_FOR: `Статус для {pin}`,
    STATUS_INDICATOR: `Индикатор статуса`,
    STATUS_REASON: `Причина статуса`,
    STOLEN_DATE: `Дата кражи`,
    STORE: `Дилерский центр`,
    STORE_IS_REQUIRED: `Требуется указать дилерский центр.`,
    STORE_NUMBER_IS_REQUIRED: `Требуется указать номер дилерского центра.`,
    STREET_1: `Улица1`,
    STREET_2: `Улица 2`,
    SUB: `Отправить`,
    SUB_CLAIM_TYPE: `Тип второстепенной рекламации`,
    SUB_TYPE: `Подтип`,
    SUBMISSION_DATE: `Дата подачи`,
    SUBMIT: `Отправить`,
    SUBMIT_AUDIT: `Отправить результаты аудита`,
    SUBMIT_AUDIT_FOR: `Отправить результаты аудита для {dealer}`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Отправить рекламацию с полным дебетованием для {claimNumber}`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Отправить рекламацию с частичным дебетованием для {claimNumber}`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Отправить рекламацию по процентному дебету для {claimNumber}`,
    SUBMIT_REQUEST: `Отправить запрос`,
    SUBMITTED: `статусу “ ОТПРАВЛЕНО ” `,
    SUBMITTED_AVAILABLE_TO_EDIT: `Отправлено (доступно для редактирования)`,
    SUCCESS: `Успех`,
    SUCCESS_MESSAGE_TITLE: `Операция успешно выполнена:`,
    SUCCESS_MESSAGES_TITLE: `Ряд операций успешно выполнен:`,
    SUPPLIER_WARRANTY: `Гарантия поставщика`,
    SURVEY_QUESTIONS: `Вопросы опроса`,
    SUSPENDED: `Приостановлено`,
    SWEDISH: `Шведский`,
    SYSTEM_SELECTED_CLAIMS: `Рекламации, выбранные системой`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT: `Рекламации, выбранные системой ({count})`,
    TABM: `TABM`,
    TAX: `Налог`,
    TCSM: `TCSM`,
    TCSM_COMMENTS: `Комментарии Менеджера TCSM`,
    TCSM_ID: `TCSM ID`,
    TECH_ID: `Идентификатор техника`,
    TERMINATED: `Прекращено`,
    TERMINATES: `Истекает`,
    TERRITORY: `Территория`,
    TEST: `Проверка`,
    TEST_RESULTS_CODE: `Результаты теста – код`,
    THEME: `Тема`,
    TIME_LIMIT: `Лимит времени`,
    TIME_ZONE: `Часовой пояс`,
    TITLE: `заглавие`,
    TITLE_IS_REQUIRED: `Требуется название`,
    TO: `По`,
    TODAY: `Сегодня`,
    TOO_MANY_RESULTS: `Запрос вернул слишком много результатов. Уменьшите количество поисковых терминов и повторите попытку.`,
    TOTAL: `Всего`,
    TOTAL_AMOUNT: `Общая сумма`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `Всего в PLN`,
    TOTAL_APPROVED: `Всего утверждено`,
    TOTAL_APPROVED_CLAIM_VALUE: `Утвержденная общая сумма рекламаций`,
    TOTAL_APPROVED_INCLUDING_TAXES: `Всего утверждено, включая налоги`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES: `Всего утвержденных рекламаций без дополнительных выплат`,
    TOTAL_CONTRIBUTION: `Всего взносов`,
    TOTAL_REIMBURSED: `Всего возмещено`,
    TOTAL_REIMBURSED_WITH_CURRENCY: `Всего возмещено ({currency})`,
    TOTAL_REQUESTED: `Всего запрошено`,
    TOTAL_REQUESTED_CLAIM_VALUE: `Запрошенная общая сумма рекламаций`,
    TOTAL_UNPAID: `Всего не оплачено`,
    TRACKING_NUMBER: `Номер для отслеживания`,
    TRANSFER: `Трансфер`,
    TRANSFER_ALL: `Передать все`,
    TRANSFER_APPROVALS: `Утверждение трансферов`,
    TRANSFER_APPROVALS_TAB: `Утверждение трансферов ({count})`,
    TRANSFER_CREATED: `Создан трансфер`,
    TRANSFER_DEALER_RECOMMENDATIONS: `Рекомендации по передаче дилерам`,
    TRANSFER_REJECTED: `Перенос отклонен`,
    TRANSFER_UPDATED_SUCCESSFULLY: `Данные о передаче успешно обновлены.`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `Рекомендация для всех дилеров о передаче`,
    TRANSFERS: `Трансферы`,
    TRAVEL: `Дорожные расходы`,
    TURKISH: `турецкий`,
    TWO_PERCENT_WITHHOLD_VALUE: `2% удерживаемого значения`,
    TYPE: `Тип`,
    TYPES: `Типы`,
    UNABLE_TO_CONTACT_THE_SERVER: `Не удается подключиться к серверу.`,
    UNABLE_TO_COPY_ATTACHMENTS: `Нам не удалось скопировать вложения из исходной рекламации. Перед отправкой новой рекламации выполните проверку.`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS: `Не удается загрузить сведения о клиенте.`,
    UNDO: `Отменить`,
    UNDO_REGISTRATION: `Отмена регистрации`,
    UNDO_REGISTRATION_SUCCESSFULL: `Отмена регистрации выполнена успешно`,
    UNIT: `Отделение`,
    UNIT_1: `Отделение 1`,
    UNIT_2: `Отделение 2`,
    UNIT_3: `Отделение 3`,
    UNIT_OF_MEASURE: `Единица измерения`,
    UNPAID_LABOR: `Неоплаченная работа`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: `Неоплаченные дополнительные работы — кроме программ PIP`,
    UNPAID_LABOR_ADDITIVES_PIPS: `Неоплаченные дополнительные работы — по программам PIP`,
    UNPAID_OTHER_CREDITS: `Неоплаченные другие кредиты`,
    UNPAID_PARTS: `Неоплаченные запчасти`,
    UNPAID_PARTS_ADDITIVE: `Неоплаченные дополнительные запчасти`,
    UNPAID_TRAVEL: `Неоплаченная поездка`,
    UNRECONCIL: `Несовместимо`,
    UNRECONCILE_CLAIM : `Невыверенная рекламация`,
    UNSUB: `Редактировать`,
    UNSUBMIT_CLAIM: `Редактировать Рекламация`,
    UPDATE: `Обновить`,
    UPDATE_CUSTOMER_INFORMATION: `Обновление информации о клиенте`,
    UPDATE_LABOR_RATES: `Обновление тарифа на оплату труда`,
    UPDATE_LAYOUT: `Обновить макет`,
    UPDATE_MACHINE_STATUS: `Обновление статуса машины`,
    UPDATE_MACHINE_STATUS_HISTORY: `Журнал обновлений статуса машины`,
    UPDATE_REGISTRATION: `Обновить регистрацию`,
    UPDATE_SELECTED: `Обновить выбранное`,
    UPDATED: `Обновлено`,
    UPDATED_BY: `Обновлено`,
    UPDATED_DATE_FROM: `Дата обновления с`,
    UPDATED_DATE_TO: `Дата обновления по`,
    UPLOAD_DOCUMENT: `Выгрузить документ`,
    UPTIME_ASSURANCE: `Страхование от безотказной работы`,
    USEFUL_LINKS: `Полезные ссылки`,
    USER: `пользователь`,
    USER_PREFERENCES_UPDATED: `Предпочтения пользователя обновлены.`,
    USER_SELECTED: `Выбранные пользователем`,
    USER_SELECTED_CLAIMS_WITH_COUNT: `Рекламации, выбранные пользователем ({count})`,
    USERS_INFORMATION: `Информация о пользователях`,
    VALIDATE: `Подтвердить`,
    VALIDATE_CLAIM: `Подтвердить рекламацию`,
    VALUE: `Значение`,
    VALUE_OF_REPAIR: `Стоимость ремонта`,
    VIEW_CLAIM: `Просмотреть рекламацию`,
    VIEW_DETAILS: `Просмотр сведений`,
    VIEW_OPEN_PIPS: `Просмотр открытых PIP`,
    VIEW_PIP: `Просмотр PIP`,
    VIEW_PRODUCTS: `Просмотр продуктов`,
    VIEW_PRODUCTS_AND_UPDATE_INFO: `Просмотр продуктов и Обновить информацию`,
    VIEW_UPDATE: `Просмотреть/обновить`,
    VSR_MESSAGES: `Сообщения VSR`,
    WAITING_FOR_DLR_INV: `Ожидание счета-фактуры дилера`,
    WAITING_FOR_INVOICE: `Ожидание счета-фактуры ({count})`,
    WAITING_SINCE: `Ожидание с`,
    WARNING_MESSAGE_TITLE: `Отправлено предупреждение:`,
    WARNING_MESSAGES: `Предупреждающие сообщения`,
    WARNING_MESSAGES_TITLE: `Отправлено несколько предупреждений:`,
    WARRANTY: `Гарантия`,
    WARRANTY_ADMIN: `Администратор гарантийного обслуживания`,
    WARRANTY_CLAIM_TYPE: `Тип рекламации по гарантии`,
    WARRANTY_COVERAGE: `Условия гарантии`,
    WARRANTY_EXPIRATION: `Истечение срока гарантии`,
    WARRANTY_TYPE: `Тип гарантии`,
    WARRANTY_TYPES: `Типы гарантий`,
    WEAR_PARTS: `Изнашиваемые детали`,
    WEAR_PARTS_COVERAGE: `Покрытие изнашиваемых деталей`,
    WELCOME: `Добро пожаловать`,
    WINTERIZATION: `Подготовка к зиме`,
    WIP: `Текущая работа`,
    WITH_ADDITIVES: `С надбавками`,
    WITNESS_FIRST_NAME: `Имя свидетеля`,
    WITNESS_LAST_NAME: `Фамилия свидетеля`,
    WORK_ORDER: `Заказ-наряд`,
    WORK_ORDER_NUMBER: `Номер заказ-наряда`,
    WORK_ORDER_ONE: `Заказ-наряду 1`,
    WORK_ORDER_ONE_IS_REQUIRED: `Требуется указать Заказ-наряду 1.`,
    WORK_ORDER_THREE: `Заказ-наряд 3`,
    WORK_ORDER_THREE_IS_REQUIRED: `Требуется указать Заказ-наряду 3.`,
    WORK_ORDER_TWO: `Заказ-наряду 2`,
    WORK_REPAIR_ORDER: `Заказ на работу/ремонт`,
    YES: `ДА`,
    YES_LOWERCASE: `Да`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/ru.js